import React from 'react';
import ReactHighlightSyntax from 'react-highlight-syntax';

const language = 'Bash';
const theme = 'GithubDark';
const copy = true;
const copyBtnTheme = 'Dark';

const Code = ({ children }) => {
    return (
        <ReactHighlightSyntax language={language} theme={theme} copy={copy} copyBtnTheme={copyBtnTheme}>
            {children}
        </ReactHighlightSyntax>
    );
}  
export default Code;